import _extends from "@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState, useRef, useContext } from "react";
import { connect } from 'react-redux';
import { AuthenticationState } from "react-aad-msal";
import Wrapper from "../wrapper/Wrapper";
import { Container, Row, Col, Button } from "react-bootstrap";
import { MobileTotal, LocationInfo } from "./CartHelpers";
import MediaQuery from 'react-responsive';
import { accountHelper, checkoutStep, formatter, getLoyaltyStorage } from "../../util";
import { getAddressType } from "../../util/menu/getAddressType";
import { StateBootstrapButton as StateButton, RouterStateButton } from "../forms/elements/Button";
import { GlobalStateProvider, GlobalStateContext, isValidPaymentData } from './tokenex/InMemoryState';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Summary, PickupInfo, DeliveryMethod, AddressInfo, PaymentInfo, BillingAddress, PersonalInfo, CurbsideInfo, CompletionModal, RewardsRedeemedModule } from './CheckoutHelpers'; // Redux

import { accountDuck } from "../../ducks/account";
import { cartDuck } from "../../ducks/cart";
import { errorDuck } from '../../ducks/error';
var accountOperations = accountDuck.operations;
var cartOperations = cartDuck.operations;
var errorOperations = errorDuck.operations; // Form Elements

import { Form } from 'formik'; // Validation schema

import InlineError from '../state/InlineError';
import { formikEnhancer } from "./formik/formikEnhancer";
import { AddressValidationModal } from "./CheckoutHelpers/AddressValidation";
import { formatPhoneNumber } from "../../util/helper";
import { Debug } from "../forms/Debug";
import { formStart, formComplete, orderError } from '../../util';

var formStartTracker = function formStartTracker() {
  formStart({
    identifier: 'CheckoutPage',
    name: 'Checkout'
  });
};

var formCompleteTracker = function formCompleteTracker() {
  formComplete({
    identifier: 'CheckoutPage',
    name: 'Checkout'
  });
};

var orderErrorTracker = function orderErrorTracker(message) {
  orderError({
    message: message
  });
};

var receiveError = errorOperations.receiveError;
var resetError = errorOperations.resetError;

var CheckoutPage = function CheckoutPage(props) {
  var _account$aadResponse2, _account$aadResponse3, _props$fields, _props$fields$RewardR, _props$fields$RewardR2;

  var _props$cost = props.cost,
      cost = _props$cost === void 0 ? {
    Total: 1
  } : _props$cost,
      _props$cart = props.cart,
      cart = _props$cart === void 0 ? [] : _props$cart,
      _props$paypal = props.paypal,
      paypal = _props$paypal === void 0 ? {} : _props$paypal,
      _props$destructuredCa = props.destructuredCart,
      destructuredCart = _props$destructuredCa === void 0 ? {} : _props$destructuredCa,
      _props$deliveryMethod = props.deliveryMethod,
      deliveryMethod = _props$deliveryMethod === void 0 ? {} : _props$deliveryMethod,
      _props$guest = props.guest,
      guest = _props$guest === void 0 ? true : _props$guest,
      _props$resetGoToCheck = props.resetGoToCheckout,
      resetGoToCheckout = _props$resetGoToCheck === void 0 ? function () {
    return console.log("resetGoToCheckout");
  } : _props$resetGoToCheck,
      _props$setTip = props.setTip,
      setTip = _props$setTip === void 0 ? function () {
    return console.log("checkoutPage set");
  } : _props$setTip,
      _props$handleLogin = props.handleLogin,
      handleLogin = _props$handleLogin === void 0 ? function () {
    return console.log("getDeliveryModesNotFound");
  } : _props$handleLogin,
      _props$setDeliveryMod = props.setDeliveryMode,
      setDeliveryMode = _props$setDeliveryMod === void 0 ? function () {
    return new Promise(function (resolve) {
      return resolve(console.log("DeliveryMode"));
    });
  } : _props$setDeliveryMod,
      _props$setDeliveryInf = props.setDeliveryInfo,
      setDeliveryInfo = _props$setDeliveryInf === void 0 ? function () {
    return new Promise(function (resolve) {
      return resolve(console.log("DeliveryInfo"));
    });
  } : _props$setDeliveryInf,
      _props$setCurbside = props.setCurbside,
      setCurbside = _props$setCurbside === void 0 ? function () {
    return new Promise(function (resolve) {
      return resolve(console.log("Curbside"));
    });
  } : _props$setCurbside,
      _props$setMixCartCust = props.setMixCartCustomFields,
      setMixCartCustomFields = _props$setMixCartCust === void 0 ? function () {
    return new Promise(function (resolve) {
      return resolve(console.log("testing mix cart"));
    });
  } : _props$setMixCartCust,
      values = props.values,
      _props$submitHandler = props.submitHandler,
      submitHandler = _props$submitHandler === void 0 ? function () {
    return console.log("submitHandler");
  } : _props$submitHandler,
      _props$handleBackToCa = props.handleBackToCart,
      handleBackToCart = _props$handleBackToCa === void 0 ? function () {
    return console.log("handleBackToCart");
  } : _props$handleBackToCa,
      _props$getAccountAddr = props.getAccountAddress,
      getAccountAddress = _props$getAccountAddr === void 0 ? function () {
    return console.log('getAccountAddress');
  } : _props$getAccountAddr,
      _props$postAccountAdd = props.postAccountAddress,
      postAccountAddress = _props$postAccountAdd === void 0 ? function () {
    return console.log('postAccountAddress');
  } : _props$postAccountAdd,
      _props$putAccountAddr = props.putAccountAddress,
      putAccountAddress = _props$putAccountAddr === void 0 ? function () {
    return console.log('putAccountAddress');
  } : _props$putAccountAddr,
      _props$receiveAddress = props.receiveAddress,
      receiveAddress = _props$receiveAddress === void 0 ? function () {
    return console.log('receiveAddress');
  } : _props$receiveAddress,
      _props$getShippingMod = props.getShippingModes,
      getShippingModes = _props$getShippingMod === void 0 ? function () {
    return console.log('getShippingModes');
  } : _props$getShippingMod,
      _props$setPaypalOrder = props.setPaypalOrder,
      setPaypalOrder = _props$setPaypalOrder === void 0 ? function () {
    return console.log("setPaypalOrder");
  } : _props$setPaypalOrder,
      _props$setPostLoyalty = props.setPostLoyaltyData,
      setPostLoyaltyData = _props$setPostLoyalty === void 0 ? function () {
    return console.log("setPostLoyaltyData");
  } : _props$setPostLoyalty,
      setFieldTouched = props.setFieldTouched,
      errors = props.errors,
      deliveryFail = props.deliveryFail,
      _props$getGiftCardSch = props.getGiftCardSchema,
      getGiftCardSchema = _props$getGiftCardSch === void 0 ? function () {
    return "";
  } : _props$getGiftCardSch,
      schema = props.schema,
      applePayScheme = props.applePayScheme,
      googlePayScheme = props.googlePayScheme,
      _props$giftCardInfo = props.giftCardInfo,
      giftCardInfo = _props$giftCardInfo === void 0 ? [] : _props$giftCardInfo,
      _props$removeAllGiftC = props.removeAllGiftCards,
      removeAllGiftCards = _props$removeAllGiftC === void 0 ? function () {
    return "";
  } : _props$removeAllGiftC,
      location = props.location,
      setRetail = props.setRetail,
      isFood = props.isFood,
      isCatering = props.isCatering,
      isRetail = props.isRetail,
      isPostingTip = props.isPostingTip,
      isValidatingOrder = props.isValidatingOrder,
      shippingMode = props.shippingMode,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$getSavedCredit = props.getSavedCreditCards,
      getSavedCreditCards = _props$getSavedCredit === void 0 ? function () {
    return "";
  } : _props$getSavedCredit,
      setFieldValue = props.setFieldValue,
      accountInfo = props.accountInfo,
      authState = props.authenticationState,
      _props$creditCardInfo = props.creditCardInfo,
      creditCardInfo = _props$creditCardInfo === void 0 ? [] : _props$creditCardInfo,
      token = props.token,
      account = props.account,
      addresses = props.addresses,
      addressBook = props.addressBook,
      validateAddress = props.validateAddress,
      _props$postNewsletter = props.postNewsletter,
      postNewsletter = _props$postNewsletter === void 0 ? function () {
    return "";
  } : _props$postNewsletter,
      _props$setErrors = props.setErrors,
      setErrors = _props$setErrors === void 0 ? function () {
    return "";
  } : _props$setErrors,
      _props$getTokenExAuth = props.getTokenExAuthToken,
      getTokenExAuthToken = _props$getTokenExAuth === void 0 ? function () {
    return console.log('getTokenExAuthToken');
  } : _props$getTokenExAuth,
      isSubmitting = props.isSubmitting,
      validateForm = props.validateForm,
      submitForm = props.submitForm;
  var isTokenExEnabled = props.fullCart.isTokenExEnabled;
  var foodMethod = deliveryMethod.foodDeliveryMode;
  var caterMethod = deliveryMethod.caterDeliveryMode;
  var retailMethod = deliveryMethod.retailDeliveryMode || shippingMode;
  var mixCart = isCatering && isFood || false;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      sections = _useState2[0],
      setSections = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      accountInfoModified = _useState4[0],
      setAccountInfo = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      hasFlipped = _useState6[0],
      setHasFlipped = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      addressValidation = _useState8[0],
      setAddressValidation = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isPaypal = _useState10[0],
      setIsPaypal = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      externalPayment = _useState12[0],
      setExternalPayment = _useState12[1];

  var _useState13 = useState(['card']),
      _useState14 = _slicedToArray(_useState13, 2),
      paymentType = _useState14[0],
      setPaymentType = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      addressDisable = _useState16[0],
      setAddressDisable = _useState16[1];

  var _useState17 = useState({}),
      _useState18 = _slicedToArray(_useState17, 2),
      payPalDetails = _useState18[0],
      setPayPalDetails = _useState18[1];

  var _useState19 = useState(null),
      _useState20 = _slicedToArray(_useState19, 2),
      ccScheme = _useState20[0],
      setCcScheme = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      removeTipAndEntitlementsState = _useState22[0],
      setRemoveTipAndEntitlementsState = _useState22[1];

  var flags = useFlags();
  var releaseGoogleRwgToken = flags['releaseGoogleRwgToken'] ? flags['releaseGoogleRwgToken'] : false;
  useEffect(function () {
    formStartTracker();
  }, []);
  useEffect(function () {
    if (caterMethod || foodMethod || isRetail) {
      constructSections(caterMethod, foodMethod, isRetail);
    }

    var methodType = foodMethod || caterMethod || null;

    if (methodType !== null && (methodType === 'curbside' || methodType === 'pickup') && !mixCart) {
      setDeliveryMode(deliveryMethod).then(function (res) {
        console.log('Set deliveryMethod: ', res);
      }).catch(function (e) {
        console.log('Error setting curbside');
      });
    }

    resetGoToCheckout();
  }, [foodMethod, caterMethod, isRetail, mixCart]);
  useEffect(function () {
    removeAllGiftCards();
    checkoutStep({
      'step': 1,
      'option': 'Checkout Initiated'
    });
  }, [isRetail, isFood, isCatering, authState]);
  useEffect(function () {
    getGiftCardSchema();
    setTimeout(function () {
      var field = document.querySelector('[name="firstName"]');
      field.focus();
    }, 500);
  }, []);
  useEffect(function () {
    if (props.ccScheme) {
      setCcScheme(props.ccScheme);
    }
  }, [props.ccScheme]);
  useEffect(function () {
    var _account$aadResponse;

    // Retry after token refresh
    if (authState === AuthenticationState.Authenticated && (account === null || account === void 0 ? void 0 : (_account$aadResponse = account.aadResponse) === null || _account$aadResponse === void 0 ? void 0 : _account$aadResponse.jwtIdToken)) {
      getAccountAddress();
      getSavedCreditCards();
    }
  }, [account === null || account === void 0 ? void 0 : (_account$aadResponse2 = account.aadResponse) === null || _account$aadResponse2 === void 0 ? void 0 : _account$aadResponse2.jwtIdToken]);
  useEffect(function () {
    if (isPaypal) {
      var payPalinfo = {
        firstName: paypal.firstName,
        lastName: paypal.lastName,
        email: paypal.email,
        phone: paypal.phone,
        shippingStreetAddress: paypal.shippingStreetAddress,
        shippingStreetAddress2: paypal.shippingStreetAddress2,
        shippingCity: paypal.shippingCity,
        shippingState: paypal.shippingState,
        shippingZip: paypal.shippingZip,
        retailStreetAddress: paypal.shippingStreetAddress,
        retailStreetAddress2: paypal.shippingStreetAddress2,
        retailCity: paypal.shippingCity,
        retailState: paypal.shippingState,
        retailZip: paypal.shippingZip,
        country: paypal.country,
        countryCode: paypal.countryCode,
        billingStreetAddress: paypal.shippingStreetAddress,
        billingCity: paypal.shippingCity,
        billingState: paypal.shippingState,
        billingZip: paypal.shippingZip,
        paymentMethod: "paypal",
        isPrimary: false,
        paypalTransaction: paypal.paypalTransaction
      };
      Object.keys(payPalinfo).forEach(function (key) {
        setFieldValue(key, payPalinfo[key], false);
      }); // Force focus to avoid validation issue

      setTimeout(function () {
        var field = document.querySelector('[name="firstName"]');
        field.focus();
      }, 500);
    }
  }, [isPaypal]);
  var initialTotal = cost.Total;
  useEffect(function () {
    if (cost.Total !== initialTotal) {
      if (isPaypal) {
        var actions = paypal.actions;
        actions.order.patch([{
          op: 'replace',
          path: '/purchase_units/@reference_id==\'default\'/amount',
          value: {
            currency_code: 'USD',
            value: ref.cost.Total.toFixed(2)
          }
        }]); // .then(() => {
        //   actions.order.authorize().then((details) => {
        //     payPalinfo = {
        //       ...payPalinfo,
        //       paypalTransaction: details.purchase_units[0].payments.authorizations[0].id,
        //       paypalId: details.id,
        //     }
        //     setPaypalOrder(payPalinfo);
        //   })
        // }).catch(err => console.log(err))
      }
    }
  }, [account === null || account === void 0 ? void 0 : (_account$aadResponse3 = account.aadResponse) === null || _account$aadResponse3 === void 0 ? void 0 : _account$aadResponse3.jwtIdToken]);
  useEffect(function () {
    if (cart.length && !hasFlipped) {
      setHasFlipped(true);
      checkoutStep({
        actionField: {
          'step': 1,
          'option': 'Checkout Initiated'
        },
        cartInfo: cart
      });
    }
  }, [cart, hasFlipped]);
  useEffect(function () {
    if (authState === AuthenticationState.Authenticated && (addresses === null || addresses === void 0 ? void 0 : addresses.length)) {
      loadAddressBook(props.addresses);
    }
  }, [addresses]);
  useEffect(function () {
    if (authState === AuthenticationState.Authenticated) {
      var _loyaltyStorage$accou, _loyaltyStorage$accou2, _loyaltyStorage$accou3, _loyaltyStorage$accou4;

      var _account = accountHelper(props.accountInfo);

      var loyaltyStorage = getLoyaltyStorage();
      var _fields = {
        firstName: loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.FirstName,
        lastName: loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou2 = loyaltyStorage.account) === null || _loyaltyStorage$accou2 === void 0 ? void 0 : _loyaltyStorage$accou2.LastName,
        email: Array.isArray(_account.emails) ? _account.emails[0] : _account === null || _account === void 0 ? void 0 : _account.email,
        phone: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou3 = loyaltyStorage.account) === null || _loyaltyStorage$accou3 === void 0 ? void 0 : _loyaltyStorage$accou3.HomePhone) ? formatPhoneNumber(loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou4 = loyaltyStorage.account) === null || _loyaltyStorage$accou4 === void 0 ? void 0 : _loyaltyStorage$accou4.HomePhone) : ""
      };

      if (addressBook) {
        if (addressBook.billing) {
          _fields.billingStreetAddress = addressBook.billing[0].billingStreetAddress;
          _fields.billingStreetAddress2 = addressBook.billing[0].billingStreetAddress2;
          _fields.billingCity = addressBook.billing[0].billingCity;
          _fields.billingState = addressBook.billing[0].billingState;
          _fields.billingZip = addressBook.billing[0].billingZip;
        }

        if (addressBook.shipping) {
          //Delivery
          _fields.shippingStreetAddress = addressBook.shipping[0].shippingStreetAddress;
          _fields.shippingStreetAddres2 = addressBook.shipping[0].shippingStreetAddres2;
          _fields.shippingCity = addressBook.shipping[0].shippingCity;
          _fields.shippingState = addressBook.shipping[0].shippingStreetState;
          _fields.shippingZip = addressBook.shipping[0].shippingZip; //Retail

          _fields.retailStreetAddress = addressBook.shipping[0].shippingStreetAddress;
          _fields.retailStreetAddres2 = addressBook.shipping[0].shippingStreetAddres2;
          _fields.retailCity = addressBook.shipping[0].shippingCity;
          _fields.retailState = addressBook.shipping[0].shippingStreetState;
          _fields.retailZip = addressBook.shipping[0].shippingZip;
        }
      }

      Object.keys(_fields).forEach(function (key) {
        setFieldValue(key, _fields[key]);
      });
      setAccountInfo(true);
    }
  }, [accountInfo, authState, addressBook]);

  var patchpayPalOrder = function patchpayPalOrder(payPalDetails, payload) {
    var actions = payPalDetails.actions;
    var payPalinfo = payPalDetails.payPalinfo;
    actions.order.patch([{
      op: 'replace',
      path: '/purchase_units/@reference_id==\'default\'/amount',
      value: {
        currency_code: 'USD',
        value: payPalDetails.cost.toFixed(2)
      }
    }]).then(function () {
      actions.order.authorize().then(function (details) {
        payPalinfo = _objectSpread(_objectSpread({}, payPalinfo), {}, {
          paypalTransaction: details.purchase_units[0].payments.authorizations[0].id,
          paypalId: details.id
        });
        setPaypalOrder(payPalinfo);
        payload.cardInfo = _objectSpread(_objectSpread({}, payload.cardInfo), {}, {
          PaypalTransaction: payPalinfo.paypalTransaction
        });
        submitHandler(payload);
      });
    }).catch(function (err) {
      return console.log(err);
    });
  };

  var loadAddressBook = function loadAddressBook(addresses) {
    if (addresses) {
      for (var i = 0; i < addresses.length; i++) {
        (function (i) {
          var item = addresses[i];
          var type = getAddressType(item);

          switch (type) {
            case 'billing':
              receiveAddress(item, 'billing');

            case 'shipping':
              receiveAddress(item, 'shipping');

            case 'delivery':
              receiveAddress(item, 'delivery');
          }
        })(i);
      }
    }
  };

  var handleSubmitCart = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(formikValues) {
      var _props$deliveryMethod2, _props$deliveryMethod3, _props$location, _formikValues$expDate, _formikValues$payment;

      var paymentData,
          loyaltyStorage,
          tmpMobilePayPegsEarned,
          newsletterPayload,
          payload,
          _document$cookie$matc,
          rwgToken,
          _payload,
          _loyaltyStorage$accou5,
          _loyaltyStorage$accou6,
          _loyaltyStorage$accou7,
          PaymentMethods,
          expDate,
          year,
          month,
          CardNumber,
          paymentMethods,
          _paymentData$token,
          _paymentData$token$pa,
          _paymentData$token$pa2,
          _paymentData$token$pa3,
          _paymentData$token2,
          _paymentData$token2$p,
          _paymentData$billingC,
          _paymentData$paymentM,
          _paymentData$paymentM2,
          _paymentData$paymentM3,
          _paymentData$paymentM4,
          _paymentData$paymentM5,
          _paymentData$paymentM6,
          _paymentData$paymentM7,
          _paymentData$paymentM8,
          _paymentData$paymentM9,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              paymentData = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;

              if (formikValues.paymentMethod) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", false);

            case 3:
              loyaltyStorage = getLoyaltyStorage();
              tmpMobilePayPegsEarned = window.sessionStorage.getItem('tmpMobilePayPegsEarned') || '';
              formCompleteTracker();

              if ((formikValues === null || formikValues === void 0 ? void 0 : formikValues.newsLetterEmailSignUp) === true || (formikValues === null || formikValues === void 0 ? void 0 : formikValues.smscheck) === true) {
                newsletterPayload = {
                  'firstName': formikValues.firstName,
                  'lastName': formikValues.lastName,
                  'emailAddress': formikValues.email,
                  'zipCode': formikValues.billingZip,
                  "partySize": 0,
                  'promotionId': "DS_OrderReceipt",
                  "smsOptIn": (formikValues === null || formikValues === void 0 ? void 0 : formikValues.smscheck) || false,
                  "emailOptIn": (formikValues === null || formikValues === void 0 ? void 0 : formikValues.newsLetterEmailSignUp) || false,
                  "mobilePhone": formikValues.phone
                };
                postNewsletter(newsletterPayload, 2);
              }

              payload = {
                "userType": "guest",
                "contactId": "",
                "customerId": "",
                "loggedIn": props.authenticationState === AuthenticationState.Authenticated,
                "smsCurbsideOptin": props.isFood && (formikValues === null || formikValues === void 0 ? void 0 : formikValues.smscheck) == true && ((_props$deliveryMethod2 = props.deliveryMethod) === null || _props$deliveryMethod2 === void 0 ? void 0 : _props$deliveryMethod2.foodDeliveryMode) == 'curbside',
                "caterSmsCurbsideOptin": props.isCatering && (formikValues === null || formikValues === void 0 ? void 0 : formikValues.smscheck) == true && ((_props$deliveryMethod3 = props.deliveryMethod) === null || _props$deliveryMethod3 === void 0 ? void 0 : _props$deliveryMethod3.caterDeliveryMode) == 'curbside',
                "storeTimezone": ((_props$location = props.location) === null || _props$location === void 0 ? void 0 : _props$location.StoreTimezone) || '',
                "firstName": formikValues.firstName,
                "lastName": formikValues.lastName,
                "emailAddress": formikValues.email,
                "contactNumber": formikValues.phone,
                "userIp": "127.0.0.1",
                "uRLRefferer": window.location.hostname,
                "streetAddress": formikValues.billingStreetAddress || '',
                "city": formikValues.billingCity || '',
                "billingAccountId": isRetail ? 1 : 0,
                "billingMethod": formikValues.paymentMethod,
                "billingZip": formikValues.billingZip || '',
                loyaltyInfo: {
                  "loyaltyCustomerID": "",
                  "loyaltyAccountStatus": "",
                  "loyaltyPegBalance": "",
                  "loyaltyPegsEarned": ""
                }
              };

              if (releaseGoogleRwgToken) {
                // get rwg token
                rwgToken = ((_document$cookie$matc = document.cookie.match("(^|;)\\s*" + "rwgToken" + "\\s*=\\s*([^;]+)")) === null || _document$cookie$matc === void 0 ? void 0 : _document$cookie$matc.pop()) || "";

                if (rwgToken) {
                  payload.rwgToken = rwgToken;
                }
              }

              if (props.authenticationState === AuthenticationState.Authenticated) {
                Object.assign((_payload = payload) === null || _payload === void 0 ? void 0 : _payload.loyaltyInfo, {
                  loyaltyCustomerID: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou5 = loyaltyStorage.account) === null || _loyaltyStorage$accou5 === void 0 ? void 0 : _loyaltyStorage$accou5.ExternalCustomerId) || '',
                  loyaltyAccountStatus: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou6 = loyaltyStorage.account) === null || _loyaltyStorage$accou6 === void 0 ? void 0 : _loyaltyStorage$accou6.Status) || '',
                  loyaltyPegBalance: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou7 = loyaltyStorage.account) === null || _loyaltyStorage$accou7 === void 0 ? void 0 : _loyaltyStorage$accou7.Balance) || '',
                  loyaltyPegsEarned: Number(tmpMobilePayPegsEarned)
                });
              }

              PaymentMethods = [];
              expDate = (formikValues === null || formikValues === void 0 ? void 0 : (_formikValues$expDate = formikValues.expDate) === null || _formikValues$expDate === void 0 ? void 0 : _formikValues$expDate.split("/")) || [];
              year = parseInt("20" + expDate[1]);
              month = parseInt(expDate[0]);
              CardNumber = formikValues.cardNumber;

              if (isRetail) {
                CardNumber = formikValues.wptokenizeedpan ? '' : formikValues.cardNumber;
              }

              paymentMethods = (_formikValues$payment = formikValues.paymentMethod) === null || _formikValues$payment === void 0 ? void 0 : _formikValues$payment.split(',');

              if (paymentMethods.includes('card')) {
                PaymentMethods.push({
                  'SaveCardDetails': '',
                  'PaypalTransaction': '',
                  'BillingSchemeId': ccScheme,
                  'BillingMethod': 'creditcard',
                  'CardType': '',
                  'CardNumber': CardNumber,
                  'ExpiryYear': isNaN(year) ? '' : year,
                  'ExpiryMonth': isNaN(month) ? '' : month,
                  'Cvv': formikValues.cvv,
                  'Zip': formikValues.billingZip,
                  'GiftCardNumber': '',
                  'GiftCardPIN': ''
                });
              }

              if (paymentMethods.includes('gift')) {
                PaymentMethods.push({
                  "SaveCardDetails": "",
                  "PaypalTransaction": "",
                  "BillingSchemeId": schema || isRetail ? 188 : undefined,
                  "BillingMethod": "storedvalue",
                  "CardType": "",
                  "CardNumber": "",
                  "ExpiryYear": "",
                  "ExpiryMonth": "",
                  "Cvv": "",
                  "Zip": "",
                  "GiftCardNumber": formikValues.giftCardNumber,
                  "GiftCardPIN": formikValues.giftCardPin
                });
              }

              if (paymentMethods.includes('applePay')) {
                PaymentMethods.push({
                  "SaveCardDetails": "",
                  "PaypalTransaction": "",
                  "BillingSchemeId": applePayScheme,
                  "BillingMethod": "digitalWallet",
                  "lastFour": paymentData === null || paymentData === void 0 ? void 0 : (_paymentData$token = paymentData.token) === null || _paymentData$token === void 0 ? void 0 : (_paymentData$token$pa = _paymentData$token.paymentMethod) === null || _paymentData$token$pa === void 0 ? void 0 : (_paymentData$token$pa2 = _paymentData$token$pa.displayName) === null || _paymentData$token$pa2 === void 0 ? void 0 : (_paymentData$token$pa3 = _paymentData$token$pa2.split(' ')) === null || _paymentData$token$pa3 === void 0 ? void 0 : _paymentData$token$pa3[1],
                  "CardType": paymentData === null || paymentData === void 0 ? void 0 : (_paymentData$token2 = paymentData.token) === null || _paymentData$token2 === void 0 ? void 0 : (_paymentData$token2$p = _paymentData$token2.paymentMethod) === null || _paymentData$token2$p === void 0 ? void 0 : _paymentData$token2$p.network,
                  "token": JSON.stringify(paymentData.token),
                  "CardNumber": "",
                  "ExpiryYear": "",
                  "ExpiryMonth": "",
                  "Cvv": "",
                  "Zip": paymentData === null || paymentData === void 0 ? void 0 : (_paymentData$billingC = paymentData.billingContact) === null || _paymentData$billingC === void 0 ? void 0 : _paymentData$billingC.postalCode,
                  "GiftCardNumber": "",
                  "GiftCardPIN": ""
                });
              }

              if (paymentMethods.includes('googlePay')) {
                PaymentMethods.push({
                  "SaveCardDetails": "",
                  "PaypalTransaction": "",
                  "BillingSchemeId": googlePayScheme,
                  "BillingMethod": "digitalWallet",
                  "lastFour": paymentData === null || paymentData === void 0 ? void 0 : (_paymentData$paymentM = paymentData.paymentMethodData) === null || _paymentData$paymentM === void 0 ? void 0 : (_paymentData$paymentM2 = _paymentData$paymentM.info) === null || _paymentData$paymentM2 === void 0 ? void 0 : _paymentData$paymentM2.cardDetails,
                  "CardType": paymentData === null || paymentData === void 0 ? void 0 : (_paymentData$paymentM3 = paymentData.paymentMethodData) === null || _paymentData$paymentM3 === void 0 ? void 0 : (_paymentData$paymentM4 = _paymentData$paymentM3.info) === null || _paymentData$paymentM4 === void 0 ? void 0 : _paymentData$paymentM4.cardNetwork,
                  "CardNumber": "",
                  "token": paymentData === null || paymentData === void 0 ? void 0 : (_paymentData$paymentM5 = paymentData.paymentMethodData) === null || _paymentData$paymentM5 === void 0 ? void 0 : (_paymentData$paymentM6 = _paymentData$paymentM5.tokenizationData) === null || _paymentData$paymentM6 === void 0 ? void 0 : _paymentData$paymentM6.token,
                  "ExpiryYear": "",
                  "ExpiryMonth": "",
                  "Cvv": "",
                  "Zip": paymentData === null || paymentData === void 0 ? void 0 : (_paymentData$paymentM7 = paymentData.paymentMethodData) === null || _paymentData$paymentM7 === void 0 ? void 0 : (_paymentData$paymentM8 = _paymentData$paymentM7.info) === null || _paymentData$paymentM8 === void 0 ? void 0 : (_paymentData$paymentM9 = _paymentData$paymentM8.billingAddress) === null || _paymentData$paymentM9 === void 0 ? void 0 : _paymentData$paymentM9.postalCode,
                  "GiftCardNumber": "",
                  "GiftCardPIN": ""
                });
              }

              payload = _objectSpread(_objectSpread({}, payload), {}, {
                PaymentMethods: PaymentMethods
              });
              return _context.abrupt("return", submitHandler(payload));

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmitCart(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var layout = {
    background: "white",
    padding: "medium"
  };

  var handlePickup = function handlePickup(newIndex) {
    setDeliveryMode(deliveryMethod, "pickup").then(function (res) {
      setActiveCategoryIndex(newIndex);
    }).catch(function (err) {
      return console.log(err);
    });
  };

  var handleDelivery = function handleDelivery(newIndex) {
    if (props.authenticationState === AuthenticationState.Authenticated) {
      if (values.saveDeliveryAddress) {
        try {
          // Store Address
          putAccountAddress({
            isDeliveryAddress: true,
            isShippingAddress: true,
            firstName: values.firstName,
            lastName: values.lastName,
            address1: values.shippingStreetAddress,
            address2: values.shippingStreetAddress2,
            city: values.shippingCity,
            state: values.shippingState,
            zipCode: values.shippingZip
          });
        } catch (err) {// fail silently
        }
      }
    }

    setDeliveryInfo(values.shippingState, values.shippingStreetAddress, values.shippingStreetAddress2, values.shippingCity, values.shippingZip, values.phone, values.shippingOther, deliveryMethod).then(function (res) {
      if (!deliveryFail) {
        setActiveCategoryIndex(newIndex);
      }
    }).catch(function (err) {
      return console.log(err, "ERR SETDELIVERY");
    });
  };

  var handleCurbside = function handleCurbside() {
    setCurbside(values.curbsideMake, values.curbsideModel, values.curbsideColor, deliveryMethod).catch(function (err) {
      return console.log(err);
    });
  };

  var handleMixedCart = function handleMixedCart() {
    setMixCartCustomFields().then(function (res) {// console.log("mixed cart api response",res)
    }).catch(function (err) {
      return console.log(err);
    });
  };

  var addressValidationChange = function addressValidationChange() {
    //if(validateAddress) {
    setAddressValidation(!addressValidation); //}
  };

  var handleRetail = function handleRetail(newIndex) {
    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
      return "";
    };
    var addressInfo = {
      "name": "",
      "firstName": values.firstName,
      "lastName": values.lastName,
      "address1": values.retailStreetAddress || values.shippingStreetAddress,
      "address2": values.retailStreetAddress2 || values.shippingStreetAddress2,
      "city": values.retailCity || values.shippingCity,
      "state": values.retailState || values.shippingState,
      "zipPostalCode": values.retailZip || values.shippingZip,
      "country": "US",
      "countryCode": "US",
      "isPrimary": false,
      "email": values.email
    };
    setAddressDisable(true);

    if (props.authenticationState === AuthenticationState.Authenticated) {
      if (values.saveDeliveryAddress) {
        try {
          postAccountAddress({
            isDeliveryAddress: true,
            isShippingAddress: true,
            firstName: values.firstName,
            lastName: values.lastName,
            address1: values.retailStreetAddress || values.shippingStreetAddress,
            address2: values.retailStreetAddress2 || values.shippingStreetAddress,
            city: values.retailCity || values.shippingStreetAddress,
            state: values.retailState || values.shippingStreetAddress,
            zipCode: values.retailZip || values.shippingStreetAddress
          });
        } catch (err) {// fail silently
        }
      }
    }

    cb(); // retailMethod

    setRetail(addressInfo, retailMethod).then(function (res) {
      setActiveCategoryIndex(newIndex);
    }).catch(function (err) {
      return console.log(err);
    });
  };

  var constructSections = function constructSections(caterMethod, foodMethod, isRetail) {
    var sections = ["1method"];
    if (guest) sections.push("2guest");
    if (foodMethod) constructHelp(foodMethod, sections);
    if (caterMethod) constructHelp(caterMethod, sections);

    if (isRetail) {
      sections.push("6retail");
      setFieldValue("isRetail", "true");
    } else {
      setFieldValue("isRetail", "false");
    }

    sections.push("7payment");
    setSections(sections.sort());
  }; //  Function greatly in need of a refactor.  Basicaclly to make sure the order is always curbside, pickup, dispatch this logic is needed.


  var constructHelp = function constructHelp(singleType, array) {
    if (singleType === "dispatch" || singleType === "delivery") {
      setFieldValue("isDelivery", "true");

      if (array.includes("3dispatch")) {
        return;
      }

      array.push("3dispatch");
    }

    if (singleType === "curbside") {
      setFieldValue("isCurbside", "true");

      if (array.includes("5curbside")) {
        return;
      }

      array.push("5curbside");
      return;
    }
  };

  var handleContinue = function handleContinue(index, fields, invalidArg) {
    var func = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : setActiveCategoryIndex;
    var retry = false;

    if (isPaypal) {
      retry = true;
    }

    handleMixedCart();
    var invalid = invalidArg;
    fields.forEach(function (field) {
      setFieldTouched(field, true);

      if (Boolean(errors[field])) {
        invalid = true;
      }
    });

    if (invalid && retry) {
      retry = false;
      invalid = false;
      fields.forEach(function (field) {
        setFieldTouched(field, true, false);

        if (Boolean(errors[field])) {
          invalid = true;
        }
      });
    }

    if (!invalid) {
      return func(index);
    } else {
      try {
        orderErrorTracker(JSON.stringify(errors));
      } catch (e) {}

      console.log("ERRORS WERE FOUND", fields, errors);
      return false;
    }
  };

  var personalInfoFields = ["firstName", "lastName", "email", "phone"];
  var deliveryFields = ["shippingStreetAddress", "shippingStreetAddress2", "shippingCity", "shippingState", "shippingZip", "shippingOther"];
  var retailFields = ["retailStreetAddress", "retailStreetAddress2", "retailCity", "retailState", "retailZip", "retailOther"];

  if (props.authenticationState === AuthenticationState.Authenticated) {
    deliveryFields.push('saveDeliveryAddress');
    retailFields.push('saveDeliveryAddress');
  }

  var fields = personalInfoFields;
  var sectionsLength = 2;
  var paymentActive = true;
  var retailActive = true;
  var curbsideActive = false;

  if (deliveryMethod.foodDeliveryMode == "curbside" || deliveryMethod.caterDeliveryMode == "curbside") {
    curbsideActive = true;
  }

  if (sections.indexOf("6retail") >= 0) {
    fields = fields.concat(retailFields);
    sectionsLength += 1; //if(!isPaypal) {

    paymentActive = false; //}
  }

  var paymentSectionIndex = sections.indexOf("7payment");

  if (sections.indexOf("3dispatch") >= 0) {
    fields = fields.concat(deliveryFields);
    paymentActive = false;
    retailActive = false;
    sectionsLength += 1; //setActiveCategoryIndex(sections.indexOf("3dispatch"))
    //paymentSectionIndex += 1;
  } // if(paymentActive) {
  //   sectionsLength = 1;
  // }


  var AKHIcheck = Boolean(isRetail) && Boolean(values.retailState == "AK" || values.retailState == "HI") && Boolean(!retailMethod.includes("alaska"));
  var AUTHSTATE = props.authenticationState === AuthenticationState.Authenticated;

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      isPaypalSetupComplete = _useState24[0],
      setPaypalSetupComplete = _useState24[1];

  var retailIndex = sections.indexOf("6retail");
  var dispatchIndex = sections.indexOf("3dispatch");

  var _useState25 = useState(1),
      _useState26 = _slicedToArray(_useState25, 2),
      activeCategoryIndex = _useState26[0],
      setActiveCategoryIndex = _useState26[1];

  var justRetail = isRetail && !isFood && !isCatering;

  if (justRetail) {
    sectionsLength = 4;
  } else {
    if (retailIndex <= -1) {
      sectionsLength += 1;
    }
  }

  var placeDisabled = isTokenExEnabled ? Object.keys(errors).length === 0 == false : activeCategoryIndex < paymentSectionIndex + 1;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStateProvider, null, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(CompletionModal, props), /*#__PURE__*/React.createElement(AddressValidationModal, _extends({}, props, {
    hideAddressValidate: function hideAddressValidate() {
      return addressValidationChange(false);
    },
    addressValidation: addressValidation,
    handleRetail: handleRetail,
    retailIndex: retailIndex
  })), /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, /*#__PURE__*/React.createElement(MobileTotal, {
    location: location,
    total: cart.length,
    subTotalCost: cost.Subtotal,
    layout: _objectSpread(_objectSpread({}, layout), {}, {
      background: "white"
    }),
    destructuredCart: destructuredCart,
    isCatering: isCatering,
    isFood: isFood,
    isRetail: isRetail
  })), /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout,
    className: "cb-cart cb-checkout"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    lg: "8",
    className: "cb-cart__content-wrapper"
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-checkout__header cb-checkout__section-container"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: "cb-cart__h3 cb-checkout__header-text"
  }, "Checkout"), Boolean(isCatering || isFood) && /*#__PURE__*/React.createElement(Container, {
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(LocationInfo, location))))), /*#__PURE__*/React.createElement(RouterStateButton, {
    href: "/cart",
    className: "cb-button-unstyled",
    onClick: handleBackToCart
  }, "Back to cart"))), /*#__PURE__*/React.createElement(DeliveryMethod, _extends({
    cart: cart,
    deliveryMethod: deliveryMethod,
    index: sections.indexOf("1method"),
    defaultActive: true,
    activeCategoryIndex: activeCategoryIndex,
    shippingMode: shippingMode
  }, props), /*#__PURE__*/React.createElement(SectionButton, {
    index: sections.indexOf("1method"),
    activeCategoryIndex: activeCategoryIndex,
    functionName: handleContinue,
    editFunction: setActiveCategoryIndex,
    fields: [],
    editHide: true
  })), ((_props$fields = props.fields) === null || _props$fields === void 0 ? void 0 : (_props$fields$RewardR = _props$fields.RewardReedemed) === null || _props$fields$RewardR === void 0 ? void 0 : _props$fields$RewardR[0]) && props.authenticationState === AuthenticationState.Authenticated && /*#__PURE__*/React.createElement(RewardsRedeemedModule, {
    cart: props.fullCart,
    rewardsState: props.rewardsState,
    redeemRewardsCart: props.redeemRewardsCart,
    model: ((_props$fields$RewardR2 = props.fields.RewardReedemed[0]) === null || _props$fields$RewardR2 === void 0 ? void 0 : _props$fields$RewardR2.fields) || {}
  }), sections.indexOf("2guest") !== -1 && /*#__PURE__*/React.createElement(PersonalInfo, _extends({
    className: "\n                    ".concat(!isPaypal || isPaypalSetupComplete ? "" : "", "\n                  "),
    index: sections.indexOf("2guest"),
    accountInfoModified: accountInfoModified,
    AUTHSTATE: AUTHSTATE,
    activeCategoryIndex: activeCategoryIndex,
    setExternalPayment: setExternalPayment,
    setPayPalDetails: setPayPalDetails,
    externalPayment: externalPayment,
    setPaymentType: setPaymentType,
    isRetail: justRetail,
    isFood: isFood,
    isCatering: isCatering
  }, props)), sections.indexOf("3dispatch") !== -1 && /*#__PURE__*/React.createElement(AddressInfo, _extends({
    index: sections.indexOf("3dispatch"),
    activeCategoryIndex: activeCategoryIndex,
    defaultActive: true,
    accountInfoModified: accountInfoModified,
    AUTHSTATE: AUTHSTATE,
    showRetail: false,
    addressValidation: addressValidation,
    addressDisable: addressDisable
  }, props), /*#__PURE__*/React.createElement(SectionButton, {
    index: sections.indexOf("3dispatch"),
    defaultActive: true,
    activeCategoryIndex: activeCategoryIndex,
    functionName: function functionName(a, b) {
      return handleContinue(a, b, undefined, handleDelivery);
    },
    editFunction: function editFunction() {
      setActiveCategoryIndex(sections.indexOf("3dispatch"));
      setAddressDisable(false);
    },
    fields: deliveryFields,
    forceDisabled: addressValidation,
    loading: addressDisable
  })), sections.indexOf("5curbside") !== -1 && /*#__PURE__*/React.createElement(CurbsideInfo, _extends({
    index: sections.indexOf("5curbside"),
    activeCategoryIndex: activeCategoryIndex,
    defaultActive: curbsideActive
  }, props), /*#__PURE__*/React.createElement(SectionButton, {
    index: sections.indexOf("5curbside"),
    activeCategoryIndex: activeCategoryIndex,
    functionName: function functionName(a, b) {
      return handleContinue(a, b, undefined, handleCurbside);
    },
    editFunction: setActiveCategoryIndex,
    fields: ["curbsideMake", "curbsideModel", "curbsideColor"]
  })), sections.indexOf("6retail") !== -1 && /*#__PURE__*/React.createElement(AddressInfo, _extends({
    index: sections.indexOf("6retail"),
    defaultActive: retailActive,
    activeCategoryIndex: activeCategoryIndex,
    retailDeliverytype: retailMethod,
    AKHIcheck: AKHIcheck,
    accountInfoModified: accountInfoModified,
    AUTHSTATE: AUTHSTATE,
    showRetail: true,
    addressValidation: addressValidation,
    addressDisable: addressDisable
  }, props), /*#__PURE__*/React.createElement(SectionButton, {
    index: sections.indexOf("6retail"),
    activeCategoryIndex: activeCategoryIndex,
    defaultActive: true,
    section: "Address retail",
    functionName: function functionName(a, b) {
      return handleContinue(a, b, undefined, addressValidationChange);
    },
    editFunction: function editFunction(index) {
      setActiveCategoryIndex(index);
      setAddressDisable(false);
    },
    fields: fields,
    forceDisabled: addressValidation,
    loading: addressDisable
  })), sections.indexOf("7payment") !== -1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaymentInfo, _extends({
    index: paymentSectionIndex,
    isTokenExEnabled: isTokenExEnabled,
    activeCategoryIndex: retailIndex <= -1 && dispatchIndex <= -1 && activeCategoryIndex < paymentSectionIndex ? paymentSectionIndex : activeCategoryIndex,
    shippingInfo: deliveryFields,
    accountInfoModified: accountInfoModified,
    AUTHSTATE: AUTHSTATE,
    dontGetGiftCardSchema: true // defaultActive={paymentActive}
    ,
    showGiftCard: true,
    setExternalPayment: setExternalPayment,
    setPayPalDetails: setPayPalDetails,
    setPaymentType: setPaymentType,
    externalPayment: externalPayment,
    paymentType: paymentType,
    cost: cost,
    isFood: isFood,
    isCatering: isCatering,
    fields: ["cardNumber", "expDate", "cvv"],
    editFunction: setActiveCategoryIndex,
    setFieldTouched: setFieldTouched,
    validateHandler: props.validateHandler,
    functionName: function functionName(a, b) {
      var isValid = isTokenExEnabled ? isValidPaymentData(globalState) : true;

      if (isValid) {
        checkoutStep({
          actionField: {
            'step': 3,
            'option': values.paymentMethod
          },
          cartInfo: cart
        });
        handleContinue(paymentSectionIndex + 1, ["ccfirstSix"]);
      }
    }
  }, props)), !isTokenExEnabled && /*#__PURE__*/React.createElement(BillingAddress, _extends({
    index: paymentSectionIndex + 1,
    activeCategoryIndex: activeCategoryIndex,
    shippingInfo: deliveryFields,
    accountInfoModified: accountInfoModified,
    AUTHSTATE: AUTHSTATE,
    dontGetGiftCardSchema: true
  }, props), /*#__PURE__*/React.createElement(SectionButton, {
    index: paymentSectionIndex + 1,
    activeCategoryIndex: activeCategoryIndex,
    functionName: function functionName(a, b) {
      checkoutStep({
        actionField: {
          'step': 4,
          'option': values.paymentMethod
        },
        cartInfo: cart
      });
      handleContinue(a, b);
    },
    editFunction: setActiveCategoryIndex,
    fields: ["billingStreetAddress", "billingCity", "billingState", "billingZip", "billingOther"]
  })))), /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    lg: "4",
    className: "cb-cart__cost-wrapper"
  }, /*#__PURE__*/React.createElement(Summary, _extends({
    cost: _objectSpread({}, cost),
    placeDisabled: placeDisabled,
    setTip: setTip,
    setPostLoyaltyData: setPostLoyaltyData,
    AUTHSTATE: AUTHSTATE,
    isSubmitting: isSubmitting,
    submitForm: submitForm,
    validateForm: validateForm
  }, props, {
    removeTipAndEntitlementsState: removeTipAndEntitlementsState,
    setRemoveTipAndEntitlementsState: setRemoveTipAndEntitlementsState,
    paymentType: paymentType,
    handleSubmitCart: handleSubmitCart
  })))))))));
};

export var SectionButton = function SectionButton(_ref2) {
  var activeCategoryIndex = _ref2.activeCategoryIndex,
      _ref2$defaultActive = _ref2.defaultActive,
      defaultActive = _ref2$defaultActive === void 0 ? false : _ref2$defaultActive,
      index = _ref2.index,
      _ref2$section = _ref2.section,
      section = _ref2$section === void 0 ? '' : _ref2$section,
      functionName = _ref2.functionName,
      editFunction = _ref2.editFunction,
      _ref2$fields = _ref2.fields,
      fields = _ref2$fields === void 0 ? [] : _ref2$fields,
      forceDisabled = _ref2.forceDisabled,
      loading = _ref2.loading,
      editHide = _ref2.editHide;
  return /*#__PURE__*/React.createElement(React.Fragment, null, defaultActive && activeCategoryIndex < index + 1 && /*#__PURE__*/React.createElement("div", {
    className: "cb-checkout__button-wrapper"
  }, /*#__PURE__*/React.createElement(StateButton, {
    type: "button",
    className: "cb-button-primary",
    disabled: forceDisabled,
    loading: loading,
    onClick: function onClick() {
      return functionName(index + 1, fields);
    }
  }, "Save & Continue")), activeCategoryIndex >= index + 1 && !editHide && /*#__PURE__*/React.createElement("div", {
    className: "cb-checkout__button-wrapper"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      return editFunction(index);
    }
  }, "Edit")));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    account: state.account,
    addresses: state.account.addresses,
    addressBook: state.account.addressBook,
    validateAddress: state.account.validateAddress,
    shippingMode: state.cart.shippingMode,
    isPostingTip: state.cart.isPostingTip,
    isValidatingOrder: state.cart.isValidatingOrder,
    tokenEx: state.cart,
    rewardsState: state.rewards,
    ccScheme: state.cart.ccScheme,
    fullCart: state.cart
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getAccountAddress: function getAccountAddress() {
      return dispatch(accountOperations.getAccountAddress());
    },
    receiveAddress: function receiveAddress(address, type) {
      return dispatch(accountOperations.receiveAddress(address, type));
    },
    postAccountAddress: function postAccountAddress(address) {
      return dispatch(accountOperations.postAccountAddress(address));
    },
    putAccountAddress: function putAccountAddress(address) {
      return dispatch(accountOperations.putAccountAddress(address));
    },
    addressValidation: function addressValidation(validate) {
      return dispatch(accountOperations.addressValidation(validate));
    },
    getShippingModes: function getShippingModes() {
      return dispatch(cartOperations.getShippingModes());
    },
    setPaypalOrder: function setPaypalOrder(json) {
      return dispatch(cartOperations.setPaypalOrder(json));
    },
    requestPaypalOrder: function requestPaypalOrder() {
      return dispatch(cartOperations.requestPaypalOrder());
    },
    resetPaypalOrder: function resetPaypalOrder() {
      return dispatch(cartOperations.resetPaypalOrder());
    },
    getTokenExAuthToken: function getTokenExAuthToken() {
      return dispatch(cartOperations.getTokenExToken());
    },
    setPostLoyaltyData: function setPostLoyaltyData() {
      return dispatch(cartOperations.handlePostLoyaltyData());
    },
    redeemRewardsCart: function redeemRewardsCart(type) {
      return dispatch(cartOperations.handleRedeemRewards(type));
    },
    removeTipAndEntitlements: function removeTipAndEntitlements(data) {
      return dispatch(cartOperations.handleRemoveTipAndEntitlements(data));
    }
  };
};

var Checkout = connect(mapStateToProps, mapDispatchToProps)(formikEnhancer(CheckoutPage));
export { Checkout };